// extracted by mini-css-extract-plugin
export var askAiIcon = "_ng-j";
export var category = "_ng-9";
export var categoryHeader = "_ng-e";
export var container = "_ng-0";
export var group = "_ng-a";
export var groupItems = "_ng-f";
export var groupSeparator = "_ng-k";
export var loading = "_ng-1";
export var noResults = "_ng-3";
export var placeholder = "_ng-2";
export var resultContent = "_ng-5";
export var resultIcon = "_ng-c";
export var resultItem = "_ng-g";
export var resultMeta = "_ng-8";
export var resultSubtitle = "_ng-7";
export var resultSuffix = "_ng-i";
export var resultTitle = "_ng-6";
export var resultsList = "_ng-4";
export var searchGroup = "_ng-d";
export var selected = "_ng-h";
export var subgroup = "_ng-b";